import { render } from "./EditNote.vue?vue&type=template&id=20b9d75d&ts=true"
import script from "./EditNote.vue?vue&type=script&lang=ts"
export * from "./EditNote.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__